export default {
  UNSPLASH: 'Unsplash',
  ISTOCK: 'iStock',
};
